import { Dispatch, SetStateAction } from "react";
import { contains } from "helpers/coll";
import { Checkbox, FormControlLabel, SxProps, Theme } from "@mui/material";

export function EnumCheckbox<T extends string>(props: {
  value: T;
  selectedValues: T[];
  display: (t: T) => string;
  setSelectedValues: Dispatch<SetStateAction<T[]>>;
  sx?: SxProps<Theme>;
}) {
  const { value, selectedValues, setSelectedValues, display, sx } = props;
  const checked = contains(selectedValues, value);
  const onChange = (evt) => {
    const checked = evt.target.checked;
    if (checked) {
      setSelectedValues((prev) => [...prev, value]);
    } else {
      setSelectedValues((prev) => prev.filter((pt) => pt !== value));
    }
  };
  return (
    <FormControlLabel
      sx={sx}
      key={value}
      title={display(value)}
      color="primary"
      label={display(value)}
      control={<Checkbox checked={checked} onChange={onChange} size="small" color="secondary" />}
    />
  );
}
